import styled from "styled-components";

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const HeaderContent = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral[100]};
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1440px;
  gap: ${({ theme }) => theme.spacings.xs5};
  padding: ${({ theme }) => `${theme.spacings.xs3} ${theme.spacings.m}`};
`;
